import { Autocomplete, TextField } from '@mui/material'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { ETranslationNs, ISubscriptionPriceBaseWithId } from 'src/types'

interface IProps {
  name: string
  value: ISubscriptionPriceBaseWithId | null
  isLoading?: boolean
  items: ISubscriptionPriceBaseWithId[]
  error?: string
}

export const SubscriptionPricesInput = ({ name, isLoading, items, value, error }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { handleChange } = useFormikContext()

  const handlePriceChange = (event: any, value: ISubscriptionPriceBaseWithId | null) => {
    handleChange({
      target: {
        name,
        value,
      },
    })
  }

  return (
    <Autocomplete
      disablePortal
      autoHighlight
      options={items}
      value={value}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      getOptionLabel={(option) => option?.amount + ' USD'}
      renderOption={(props, option) => <li {...props}>{option.amount} USD</li>}
      fullWidth
      onChange={handlePriceChange}
      loading={isLoading}
      loadingText={t('loading-text-notification.v')}
      renderInput={(props) => (
        <TextField
          {...props}
          autoComplete="off"
          variant="standard"
          style={{ height: '100%', width: '100%' }}
          size="small"
          label={t('subscription-price-label.v')}
          name={name}
          type="text"
          FormHelperTextProps={{ error: !!error }}
          helperText={error && <HelperWrapper t={error} />}
        />
      )}
    />
  )
}
